import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// 数据大屏组件库 
import dataV from '@jiaminghi/data-view'
// element UI
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as echarts from 'echarts';

// 创建应用实例
const app = createApp(App)

// 挂载 echarts 到全局属性
app.config.globalProperties.$echarts = echarts

// 链式注册插件并挂载应用
app
  .use(store)
  .use(ElementPlus)
  .use(dataV)
  .use(router)
  .mount('#app')